function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import concat from 'ramda/src/concat';
import find from 'ramda/src/find';
import pathOr from 'ramda/src/pathOr';
import propEq from 'ramda/src/propEq';
import { FeatureToggleConstants } from 'invision-core';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { FeatureTogglesSelector } from 'invision-core/src/components/featureToggle/featureToggle.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { OFFER_STATUS_INDICATOR_STATUS, NON_BULK_SERVICE_STATUSES } from 'invision-core/src/constants/status.constants';
import customerCareKeys from '../../../../../locales/keys';
import { getFriendlyName } from '../../../../../reducers/selectors/billing.payments.invoice.selectors.helper';
import { NA } from '../../../../../reducers/constants/billing.payments.constants';
import { MANAGE_SERVICE_FEATURES_ORDER_STATE_NAME } from '../../../../../reducers/constants/products.wizard.constants';
import { BILLER_RULE_INSTANCE_TYPE_COMBINATIONS, BILLER_RULE_INSTANCE_TYPE, ENTITLEMENT_CONTEXT_TYPES, ENTITLEMENT_SHARE_STATUS } from '../../../../../customercare.constants';
import { getOptionsByActiveBriType } from '../offering/offering.component.helper';
import { USAGE_CAPS_URL } from '../../../servicesAndUsage/usageCaps/usage.caps.constants';
import { ORDER_STATUS } from '../../../orderHistory/orderDetails/order.details.constants';
import { DASHBOARD_ROUTE } from '../../../../../reducers/constants/dashboard.constants';
import { suspendOrResumeServices } from '../../../../../reducers/actions/services.actions';
import { IsSuspendingOrResumingServicesSelector } from '../../../../../reducers/selectors/services.selectors';
import { SERVICE_USAGE_DETAILS_STATE_NAME } from '../../../servicesAndUsage/usageDetails/usage.details.config';
import { retrieveConvergentBillerAccountDetails, retrieveConvergentBillerSubscriberSummary, updateDashboardEntitlementShareStatus } from '../../../../../reducers/actions/customer.convergent.biller.actions';
import { SERVICES_AND_SHARED_ENTITLEMENTS, SERVICES_AND_SHARED_ENTITLEMENTS_TAB } from '../../../servicesAndUsage/services.and.usage.config';
import { ConvergentBillerCurrencyCodeSelector, IsUpdatingDashboardEntitlementStatusSelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { setSelectedSharedEntitlementIndex } from '../../../../../reducers/actions/shared.entitlements.actions';
import { retrieveSubscriberFinanceDetails } from '../../../../../reducers/actions/customer.devices.actions';
var ServicesContentsController = /*#__PURE__*/function () {
  function ServicesContentsController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, ServicesContentsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      customerCareKeys: customerCareKeys,
      coreLocaleKeys: CoreLocaleKeys,
      closeSuspendResumeServiceModal: this.closeSuspendResumeServiceModal.bind(this),
      ENTITLEMENT_CONTEXT_TYPES: ENTITLEMENT_CONTEXT_TYPES,
      goToUsageDetails: this.goToUsageDetails.bind(this),
      NA: NA,
      NON_BULK_SERVICE_STATUSES: NON_BULK_SERVICE_STATUSES,
      onApiError: this.onApiError.bind(this),
      onCloseUpdateFriendlyNameModal: this.onCloseUpdateFriendlyNameModal.bind(this),
      onSubmitUpdateFriendlyNameModal: this.onSubmitUpdateFriendlyNameModal.bind(this),
      suspendResumeServices: this.suspendResumeServices.bind(this),
      uiNotificationService: uiNotificationService,
      updateSelectedService: this.updateSelectedService.bind(this)
    });
  }
  return _createClass(ServicesContentsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        fetchCodeTypes: MetadataActions.codes.fetchCodeTypes,
        retrieveConvergentBillerAccountDetails: retrieveConvergentBillerAccountDetails,
        retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
        retrieveSubscriberFinanceDetails: retrieveSubscriberFinanceDetails,
        setSelectedSharedEntitlementIndex: setSelectedSharedEntitlementIndex,
        suspendOrResumeServices: suspendOrResumeServices,
        updateDashboardEntitlementShareStatus: updateDashboardEntitlementShareStatus
      };
      var mapStateToProps = function mapStateToProps(store) {
        return {
          currencyCode: ConvergentBillerCurrencyCodeSelector(store),
          features: FeatureTogglesSelector(store),
          featureTogglesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(CODES.FeatureToggleConfig, store),
          isSuspendingOrResuming: IsSuspendingOrResumingServicesSelector(store),
          isUpdatingDashboardEntitlementStatus: IsUpdatingDashboardEntitlementStatusSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.featureTogglesLoaded) {
        this.actions.fetchCodeTypes(CODES.FeatureToggleConfig);
      }
      this.updateFriendlyNameModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.updateFriendlyNameModalConfigApi = api;
        }
      };
      this.servicesSuspendResumeModalConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.servicesSuspendResumeModalAPI = event.api;
        }
      };
      this.isExpanded = true;
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this2 = this;
      if (changes.services && changes.services.currentValue && changes.services.currentValue.length > 0) {
        var getSelectedService = function getSelectedService() {
          return _this2.servicesAvailable.find(function (service) {
            return service.selected;
          });
        };
        var prevSelectedService = this.servicesAvailable ? getSelectedService() : null;
        var serviceIdentifiersMatch = function serviceIdentifiersMatch(service) {
          var previousService = pathOr(i18n.translate(customerCareKeys.HOUSEHOLD.SHARED_ENTITLEMENTS), ['service', 'ServiceIdentifier', 'Value'], prevSelectedService);
          var currentService = pathOr(i18n.translate(customerCareKeys.HOUSEHOLD.SHARED_ENTITLEMENTS), ['ServiceIdentifier', 'Value'], service);
          return previousService === currentService;
        };
        var isSelected = function isSelected(service, index) {
          if (prevExistsInCurrent) {
            return serviceIdentifiersMatch(service);
          } else if (sharedEntitlement) {
            return !service.ServiceIdentifier;
          } else {
            return index === 0;
          }
        };
        var prevExistsInCurrent = prevSelectedService ? changes.services.currentValue.some(function (service) {
          return serviceIdentifiersMatch(service);
        }) : false;
        var isSharedEntitlement = function isSharedEntitlement(service) {
          return !service.ServiceIdentifier && service.EntitlementBalances.length > 0;
        };
        var sharedEntitlement = this.services.find(isSharedEntitlement);
        this.servicesAvailable = this.services.asMutable({
          deep: true
        }).filter(function (service) {
          var hasIndividualEntitlements = service.ServiceIdentifier && getFriendlyName(service.ServiceIdentifier) !== NA;
          var hasSharedEntitlements = isSharedEntitlement(service);
          return hasIndividualEntitlements || hasSharedEntitlements;
        }).map(function (service, index) {
          service.isSharedEntitlement = isSharedEntitlement(service);
          return {
            text: _this2.getServiceWidgetTitle(service.ServiceIdentifier),
            selected: isSelected(service, index),
            service: service,
            index: index
          };
        }).sort(function (service) {
          //Make the selected service first
          return service.selected ? 0 : 1;
        });
        this.updateSelectedService(getSelectedService());
      }
    }
  }, {
    key: "sortOfferOptionsByBillerTypeTotal",
    value: function sortOfferOptionsByBillerTypeTotal(optionsToBeSorted, billerType) {
      return optionsToBeSorted.sort(function (a, b) {
        var firstItem = find(propEq(billerType, 'Type'))(concat(a.BillerRulePrices || [], a.BillerTypeAmounts || []));
        var secondItem = find(propEq(billerType, 'Type'))(concat(b.BillerRulePrices || [], b.BillerTypeAmounts || []));
        return firstItem && secondItem ? secondItem.TotalAmount - firstItem.TotalAmount : true;
      });
    }
  }, {
    key: "updateSelectedService",
    value: function updateSelectedService(service) {
      if (service) {
        this.selectedService = service.service;
        this.servicesAvailable.forEach(function (availableService) {
          availableService.selected = service.index === availableService.index;
        });
        var briOptions = getOptionsByActiveBriType(this.selectedService, PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE);
        this.sortedOneTimeOptions = this.sortOfferOptionsByBillerTypeTotal(briOptions[BILLER_RULE_INSTANCE_TYPE.ONETIME], BILLER_RULE_INSTANCE_TYPE.ONETIME);
        this.sortedRecurringOptions = this.sortOfferOptionsByBillerTypeTotal(briOptions[BILLER_RULE_INSTANCE_TYPE.RECURRING], BILLER_RULE_INSTANCE_TYPE.RECURRING);
        this.usageOnlyOptions = briOptions[BILLER_RULE_INSTANCE_TYPE_COMBINATIONS.STANDALONE_USAGE];
        this.hasOneTimeOptions = this.sortedOneTimeOptions.length > 0;
        this.hasRecurringOptions = this.sortedRecurringOptions.length > 0;
        this.hasUsageOnlyOptions = this.usageOnlyOptions.length > 0;
        this.hasPendingChange = this.getHasPendingChange();
        this.serviceFeatureStatus = this.getServiceFeatureStatus();
        this.serviceWidgetTitle = this.getServiceWidgetTitle(service.service.ServiceIdentifier);
        this.ellipsisMenuItems = this.getMoreMenuItems();
      }
    }
  }, {
    key: "getHasPendingChange",
    value: function getHasPendingChange() {
      if (!this.selectedService || !this.selectedService.ServiceFeatures) {
        return false;
      }
      return this.selectedService.ServiceFeatures.some(function (e) {
        return e.Status === OFFER_STATUS_INDICATOR_STATUS.PENDING_ACTIVE || e.Status === OFFER_STATUS_INDICATOR_STATUS.PENDING_REMOVED;
      });
    }
  }, {
    key: "getServiceFeatureStatus",
    value: function getServiceFeatureStatus() {
      if (!this.selectedService || !this.selectedService.ServiceFeatures) {
        return false;
      }
      var statuses = this.selectedService.ServiceFeatures.map(function (e) {
        return e.Status;
      });
      var bothPending = function bothPending() {
        var active = statuses.some(function (status) {
          return status === OFFER_STATUS_INDICATOR_STATUS.PENDING_ACTIVE;
        });
        var remove = statuses.some(function (status) {
          return status === OFFER_STATUS_INDICATOR_STATUS.PENDING_REMOVED;
        });
        return active && remove;
      };
      return statuses.length > 1 && bothPending() ? OFFER_STATUS_INDICATOR_STATUS.PENDING_ACTIVE : Math.max.apply(Math, statuses);
    }
  }, {
    key: "goToUsageDetails",
    value: function goToUsageDetails(entitlementIndex, entitlementId) {
      if (this.selectedService.isSharedEntitlement) {
        this.actions.setSelectedSharedEntitlementIndex(entitlementIndex);
        return this.stateGo()(SERVICES_AND_SHARED_ENTITLEMENTS, {
          tabName: SERVICES_AND_SHARED_ENTITLEMENTS_TAB.SHARED_ENTITLEMENTS
        });
      } else {
        return this.stateGo()(SERVICE_USAGE_DETAILS_STATE_NAME, {
          entitlementId: entitlementId,
          entitlementIndex: entitlementIndex,
          serviceIdentifierValue: this.selectedService.ServiceIdentifier.Value,
          serviceIdentifierName: this.selectedService.ServiceIdentifier.ServiceIdentifierName,
          serviceAttributeId: this.selectedService.ServiceIdentifier.ServiceAttributeId,
          serviceIdentifierFriendlyName: this.selectedService.ServiceIdentifier.FriendlyName,
          fromStateObject: {
            name: DASHBOARD_ROUTE,
            params: {}
          }
        });
      }
    }
  }, {
    key: "handleEllipsisMenuItemSelection",
    value: function handleEllipsisMenuItemSelection(_ref2) {
      var itemProps = _ref2.item;
      itemProps.action(itemProps);
    }
  }, {
    key: "onCloseUpdateFriendlyNameModal",
    value: function onCloseUpdateFriendlyNameModal() {
      this.showUpdateFriendlyNameModal = false;
      this.updateFriendlyNameModalConfigApi.close();
    }
  }, {
    key: "onSubmitUpdateFriendlyNameModal",
    value: function onSubmitUpdateFriendlyNameModal() {
      this.refreshServices && this.refreshServices();
      this.showUpdateFriendlyNameModal = false;
      this.updateFriendlyNameModalConfigApi.close();
    }
  }, {
    key: "goToManageFeatures",
    value: function goToManageFeatures() {
      return this.stateGo()(MANAGE_SERVICE_FEATURES_ORDER_STATE_NAME, {
        service: this.selectedService.ServiceIdentifier,
        serviceId: this.selectedService.ServiceIdentifier.Value,
        serviceTypeId: this.selectedService.ServiceIdentifier.ServiceId,
        serviceInstanceId: this.selectedService.ServiceIdentifier.ServiceInstanceId
      });
    }
  }, {
    key: "getMoreMenuItems",
    value: function getMoreMenuItems() {
      var _this3 = this;
      var ellipsisMenuItems = [];
      if (this.selectedService && !this.selectedService.isSharedEntitlement) {
        var isSelectedServiceSuspended = this.selectedService.Status === NON_BULK_SERVICE_STATUSES.SUSPENDED;
        var serviceSuspended = this.availableProducts.find(function (product) {
          if (product.OrderStatus === ORDER_STATUS.OPEN || product.OrderStatus === ORDER_STATUS.PENDING) {
            return product.Items.find(function (item) {
              return item.LockerItemId === pathOr(null, ['ServiceIdentifier', 'SubscriberProductId'], _this3.selectedService);
            });
          } else {
            return false;
          }
        });
        if (this.selectedService.usageCharges) {
          ellipsisMenuItems.push({
            title: i18n.translate(this.customerCareKeys.VIEW_USAGE_DETAILS),
            action: function action() {
              return _this3.goToUsageDetails();
            }
          });
        }
        if (this.selectedService) {
          ellipsisMenuItems.push({
            title: i18n.translate(this.customerCareKeys.MANAGE_ADD_ONS),
            action: function action(item) {
              if (!item.isLocked) {
                return _this3.goToManageFeatures();
              }
            },
            isLocked: isSelectedServiceSuspended,
            disabled: isSelectedServiceSuspended
          });
        }
        ellipsisMenuItems.push({
          title: i18n.translate(customerCareKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE),
          action: function action() {
            _this3.showUpdateFriendlyNameModal = true;
            _this3.$timeout(function () {
              _this3.updateFriendlyNameModalConfigApi.open();
            });
          }
        });
        if (this.selectedService.TopUpAvailable) {
          ellipsisMenuItems.push({
            title: i18n.translate(this.customerCareKeys.TOP_UPS.APPLY_TOP_UP),
            action: function action() {
              return _this3.stateGo()('index.customercare.customer.topups', {
                serviceId: _this3.selectedService.ServiceIdentifier.Value
              });
            }
          });
        }
        //Usage Caps
        ellipsisMenuItems.push({
          title: i18n.translate(this.customerCareKeys.USAGE_CAP_SETTINGS),
          action: function action() {
            return _this3.stateGo()(USAGE_CAPS_URL, {
              serviceId: _this3.selectedService.ServiceIdentifier.Value
            });
          }
        });
        if (this.hasSuspendAccess) {
          if (serviceSuspended) {
            ellipsisMenuItems.push({
              title: i18n.translate(this.customerCareKeys.SUSPEND_SERVICE),
              action: function action() {},
              disabled: true,
              isLocked: true,
              hasTooltip: true,
              tooltip: {
                context: {
                  description: i18n.translate(this.customerCareKeys.SUSPENDED_SERVICE_ERROR)
                },
                template: require('./suspend.service.tooltip.html'),
                icon: 'lock'
              }
            });
          } else if (this.selectedService.Status === NON_BULK_SERVICE_STATUSES.ACTIVE) {
            ellipsisMenuItems.push({
              title: i18n.translate(this.customerCareKeys.SUSPEND_SERVICE),
              action: function action() {
                return _this3.openSuspendOrResumeServiceModal();
              }
            });
          }
          if (this.selectedService.Status === NON_BULK_SERVICE_STATUSES.SUSPENDED) {
            ellipsisMenuItems.push({
              title: i18n.translate(this.customerCareKeys.RESUME_SERVICE),
              action: function action() {
                return _this3.openSuspendOrResumeServiceModal();
              }
            });
          }
        }
      }
      return ellipsisMenuItems;
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion() {
      this.isExpanded = !this.isExpanded;
    }
  }, {
    key: "launchOptionQuickEdit",
    value: function launchOptionQuickEdit() {
      return this.goToManageFeatures();
    }
  }, {
    key: "serviceFeatureIsActive",
    value: function serviceFeatureIsActive(feature) {
      return OFFER_STATUS_INDICATOR_STATUS.ACTIVE === feature.Status && !this.hasPendingChange;
    }
  }, {
    key: "enableServiceFeatureEdit",
    value: function enableServiceFeatureEdit(feature) {
      return this.serviceFeatureIsActive(feature) && feature.AllowEdit;
    }
  }, {
    key: "closeSuspendResumeServiceModal",
    value: function closeSuspendResumeServiceModal() {
      this.servicesSuspendResumeModalAPI.close();
      this.showServicesSuspendResumeModal = false;
    }
  }, {
    key: "openSuspendOrResumeServiceModal",
    value: function openSuspendOrResumeServiceModal() {
      this.services = [];
      if (this.selectedService.Status === NON_BULK_SERVICE_STATUSES.ACTIVE) {
        this.isActive = true;
        this.reasonCodes = this.suspendServiceReasonCodes;
      } else {
        this.isActive = false;
        this.reasonCodes = this.resumeServiceReasonCodes;
      }
      this.showServicesSuspendResumeModal = true;
      this.services.push(this.selectedService);
      this.$timeout(this.servicesSuspendResumeModalAPI.open);
    }
  }, {
    key: "suspendResumeServices",
    value: function suspendResumeServices(serviceDetails) {
      var _this4 = this;
      this.actions.suspendOrResumeServices(this.customerId, serviceDetails, this.isActive).then(function () {
        _this4.refreshServices && _this4.refreshServices();
        var promises = [_this4.actions.retrieveConvergentBillerSubscriberSummary(_this4.customerId), _this4.actions.retrieveConvergentBillerAccountDetails(_this4.customerId)];
        if (_this4.servicesAvailable.find(function (_ref3) {
          var service = _ref3.service;
          return !!service.deviceFinance;
        }) && !_this4.state.features[FeatureToggleConstants.OFFCYCLE_BYPASS_ARM]) {
          promises.push(_this4.actions.retrieveSubscriberFinanceDetails(_this4.customerId));
        }
        Promise.all(promises).catch(_this4.onApiError);
        _this4.uiNotificationService.transientSuccess(i18n.translate(_this4.isActive ? customerCareKeys.SUSPEND_SERVICES_SUCCESS : customerCareKeys.RESUME_SERVICES_SUCCESS));
      }).catch(function () {
        _this4.uiNotificationService.transientError(i18n.translate(_this4.isActive ? customerCareKeys.SUSPEND_SERVICES_FAILURE : customerCareKeys.RESUME_SERVICES_FAILURE));
      }).finally(function () {
        _this4.closeSuspendResumeServiceModal();
      });
    }
  }, {
    key: "getServiceWidgetTitle",
    value: function getServiceWidgetTitle(serviceIdentifier) {
      return serviceIdentifier ? "".concat(serviceIdentifier.FormattedValue, " ").concat(serviceIdentifier.FriendlyName || '') : i18n.translate(customerCareKeys.HOUSEHOLD.SHARED_ENTITLEMENTS);
    }
  }, {
    key: "updateEntitlementShareStatus",
    value: function updateEntitlementShareStatus(entitlement) {
      var _this5 = this;
      var newStatus = entitlement.SharingStatus === ENTITLEMENT_SHARE_STATUS.ENABLED ? ENTITLEMENT_SHARE_STATUS.DISABLED : ENTITLEMENT_SHARE_STATUS.ENABLED;
      this.actions.updateDashboardEntitlementShareStatus(this.customerId, entitlement.EntitlementIdentifier, newStatus).then(function () {
        return _this5.actions.retrieveConvergentBillerSubscriberSummary(_this5.customerId);
      }).then(function () {
        _this5.uiNotificationService.transientSuccess(i18n.translate(newStatus === ENTITLEMENT_SHARE_STATUS.ENABLED ? customerCareKeys.SHARING_ACTIONS.ENABLE_SUCCESS : customerCareKeys.SHARING_ACTIONS.DISABLE_SUCCESS));
      }).catch(this.onApiError);
    }
  }, {
    key: "onApiError",
    value: function onApiError(error) {
      this.uiNotificationService.transientError(error.translatedMessage);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "suspensionDate",
    get: function get() {
      return getFilterService()('localShortDate')(this.selectedService.SuspendedDate);
    }
  }]);
}();
export default {
  template: require('./services.contents.deprecated.html'),
  bindings: {
    availableProducts: '<',
    currencyCode: '<',
    customerId: '<',
    hasAdminAccess: '<',
    hasSuspendAccess: '<',
    refreshServices: '&?',
    resumeServiceReasonCodes: '<?',
    services: '<',
    stateGo: '&',
    suspendServiceReasonCodes: '<?'
  },
  controller: ServicesContentsController,
  controllerAs: 'ServicesContents'
};